import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getProjectIdFromLocation = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.projectId || null);

export default getProjectIdFromLocation;